import React, { useEffect } from "react";
import ExlyImage from "common/Components/ExlyImage";
import { useAdminPanelStore } from "features/AdminPanel/store/useAdminPanelStore";
import { ExlyModal } from "features/Common/modules/ExlyModal/ExlyModal";
import { getS3AssetCDNUrl } from "features/Common/modules/File/modules/Upload/utils/FileUpload.utils";

const ReferenceImage = ({ src, height }) => (
  <div
    className={`tw-rounded-lg tw-bg-[#EBE8FD] tw-flex tw-items-center tw-justify-center !tw-w-100 ${height} tw-mt-3 tw-mb-4`}
  >
    <ExlyImage
      src={getS3AssetCDNUrl(src)}
      alt="ref-img"
      id="ref-img"
      className="tw-w-[calc(100%-24px)] tw-h-[calc(100%-24px)]"
      loading="eager"
    />
  </div>
);

const SectionHeading = ({ text }) => (
  <div className="tw-text-[#7B7B7B] tw-text-[12px] tw-leading-normal tw-mt-[16px]">
    {text}
  </div>
);

export const SeeReferenceModal = () => {
  const setIsSeeReferenceModalOpen = useAdminPanelStore(
    (state) => state.setIsSeeReferenceModalOpen
  );
  const isSeeReferenceModalOpen = useAdminPanelStore(
    (state) => state.isSeeReferenceModalOpen
  );

  // Reset Modal State on Unmount
  useEffect(() => {
    return () => {
      setIsSeeReferenceModalOpen(null);
    };
  }, []);

  const {
    title = "",
    description = "",
    url = "",
    height,
  } = isSeeReferenceModalOpen || {};

  if (!isSeeReferenceModalOpen) return null;

  const urlArray = Array.isArray(url) ? url : [url];

  return (
    <ExlyModal
      title={title}
      header={title}
      open={isSeeReferenceModalOpen}
      onClose={() => setIsSeeReferenceModalOpen(null)}
      padded={false}
      footer={false}
      modal_props={{
        modalPaperClassName: "tw-w-[429px]",
      }}
      customFooter={<></>}
    >
      <div className="p-3">
        <div className="tw-text-[rgba(39,37,34,0.60)] tw-text-[14px] tw-font-normal tw-leading-[18px] tw-tracking-[0.23px]">
          {description}
        </div>
        <div className="tw-text-[rgba(0,0,0,0.85)] tw-text-[14px] tw-font-medium tw-leading-normal tw-mt-[16px]">
          Locations :
        </div>
        {urlArray.map((src) => {
          const srcUrl = typeof src === "string" ? src : src?.url;
          const heading = typeof src === "string" ? null : src?.heading;
          return (
            <div key={src}>
              {heading && <SectionHeading text={heading} />}
              <ReferenceImage src={srcUrl} height={height} />
            </div>
          );
        })}
      </div>
    </ExlyModal>
  );
};
